import React, { useState, useEffect } from "react";
import contact1 from "../assets/contact1.jpg";
import { useNavigate, useLocation } from "react-router-dom";

const Contact = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get prefilled email from location state or localStorage
  const [formData, setFormData] = useState({
    email:
      location.state?.prefillEmail || localStorage.getItem("demoEmail") || "",
    name: "",
    request_for: "",
    court_entity_name: "",
    phone: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [isPrefilled, setIsPrefilled] = useState(
    !!(location.state?.prefillEmail || localStorage.getItem("demoEmail"))
  );

  // Clear localStorage when component unmounts
  useEffect(() => {
    return () => {
      localStorage.removeItem("demoEmail");
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(
        "https://api-dev.mymoliapp.com/api/RequestDemo",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...formData,
            request_type: formData.request_for,
            court_name: formData.court_entity_name,
          }),
        }
      );

      if (response.ok) {
        setSubmitStatus("success");
        setFormData({
          email: "",
          name: "",
          request_for: "",
          court_entity_name: "",
          phone: "",
        });
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              Ready to <span className="text-blue-600">transform</span> your
              workflow?
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
              Schedule a personalized demo and see how our solution can
              revolutionize your business.
            </p>
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="bg-blue-50">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Request Demo Form */}
            <div className="p-8 sm:p-10 lg:p-12">
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">
                  Request a Demo
                </h2>
                <p className="text-lg text-gray-600">
                  Fill out the form and we'll get back to you within 24 hours.
                </p>
                {isPrefilled && (
                  <div className="mt-2 text-sm text-green-600">
                    We've prefilled your email from your previous request.
                  </div>
                )}
              </div>

              {submitStatus === "success" && (
                <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
                  Thank you for your request! We'll contact you soon.
                </div>
              )}

              {submitStatus === "error" && (
                <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
                  There was an error submitting your request. Please try again.
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Email*
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300"
                    placeholder="your.email@example.com"
                    required
                  />
                </div>

                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Name*
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300"
                    placeholder="Your name"
                    required
                  />
                </div>

                <div>
                  <label
                    htmlFor="request_for"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Request For*
                  </label>
                  <select
                    id="request_for"
                    name="request_for"
                    value={formData.request_for}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300 appearance-none bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoZXZyb24tZG93biI+PHBhdGggZD0ibTYgOSA2IDYgNi02Ii8+PC9zdmc+')] bg-no-repeat bg-[center_right_1rem]"
                    required
                  >
                    <option value="">Select request type</option>
                    <option value="Moli - Court Software">
                      Moli - Court Software
                    </option>
                    <option value="Moli - Interpreter Software">
                      Moli - Interpreter Software
                    </option>
                    <option value="Kulu – Court Software">
                      Kulu – Court Software
                    </option>
                    <option value="AI Terp">AI Terp</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="court_entity_name"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Court/Entity Name*
                  </label>
                  <input
                    type="text"
                    id="court_entity_name"
                    name="court_entity_name"
                    value={formData.court_entity_name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300"
                    placeholder="Court or entity name"
                    required
                  />
                </div>

                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Phone Number*
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300"
                    placeholder="+1 (___) ___-____"
                    required
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 text-white font-medium py-3 px-6 rounded-lg transition duration-300 shadow-lg hover:shadow-xl flex items-center justify-center disabled:opacity-70"
                >
                  {isSubmitting ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Processing...
                    </>
                  ) : (
                    <>
                      <svg
                        className="w-5 h-5 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                        />
                      </svg>
                      Request Demo
                    </>
                  )}
                </button>
              </form>
            </div>

            {/* Image Side */}
            <div className="hidden lg:block">
              <div className="h-full">
                <img
                  src={contact1}
                  alt="Contact us"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Benefits Section */}
          <div className="p-8 sm:p-10 lg:p-12 bg-white">
            <h3 className="text-2xl font-bold mb-6 text-center">
              What to expect from your demo:
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              <div className="bg-blue-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300">
                <div className="flex items-start">
                  <svg
                    className="flex-shrink-0 h-6 w-6 text-blue-500 mr-3 mt-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <div>
                    <h4 className="text-lg font-semibold mb-1">
                      30-minute live walkthrough
                    </h4>
                    <p className="text-gray-600">
                      A focused demonstration of our platform's key features.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300">
                <div className="flex items-start">
                  <svg
                    className="flex-shrink-0 h-6 w-6 text-blue-500 mr-3 mt-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    />
                  </svg>
                  <div>
                    <h4 className="text-lg font-semibold mb-1">
                      Tailored to your needs
                    </h4>
                    <p className="text-gray-600">
                      We customize the demo based on your specific requirements.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300">
                <div className="flex items-start">
                  <svg
                    className="flex-shrink-0 h-6 w-6 text-blue-500 mr-3 mt-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <div>
                    <h4 className="text-lg font-semibold mb-1">
                      Q&A with experts
                    </h4>
                    <p className="text-gray-600">
                      Get your questions answered by our product specialists.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg shadow-sm hover:shadow-md transition duration-300">
                <div className="flex items-start">
                  <svg
                    className="flex-shrink-0 h-6 w-6 text-blue-500 mr-3 mt-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    />
                  </svg>
                  <div>
                    <h4 className="text-lg font-semibold mb-1">
                      No obligation
                    </h4>
                    <p className="text-gray-600">
                      Zero sales pressure - just valuable information.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
